// File: src/English/EnglishTool/advancedAdverbQuestions.js
import { shuffleArray } from "./shuffleArray.js";

// Adverb Clause MC
export function buildAdverbClauseMC() {
  return {
    questionType: "MC",
    question: "Which part of this sentence is an adverb clause? 'He left early because he was tired.'",
    correctAnswer: "because he was tired",
    options: shuffleArray([
      "because he was tired",
      "He left early",
      "was tired",
      "early"
    ])
  };
}

// Comparative/Superlative Adverb
export function buildComparativeSuperlativeAdverbMC() {
  return {
    questionType: "MC",
    question: "Which is the comparative and superlative form of 'well'?",
    correctAnswer: "better, best",
    options: shuffleArray([
      "better, best",
      "well, best",
      "good, better",
      "more well, most well"
    ])
  };
}

// Intensifier
export function buildIntensifierMC() {
  return {
    questionType: "MC",
    question: "Which of these is an intensifier adverb?",
    correctAnswer: "extremely",
    options: shuffleArray([
      "extremely",
      "quickly",
      "tomorrow",
      "loudly"
    ])
  };
}

// Adverb Placement
export function buildAdverbPlacementMC() {
  return {
    questionType: "MC",
    question: "Where can the adverb go in this sentence? (Choose all that apply) 'She ___ always visits her grandmother.'",
    correctAnswer: "Before or after the verb",
    options: shuffleArray([
      "Before or after the verb",
      "Only at the end",
      "Only at the beginning",
      "Never in the sentence"
    ])
  };
}

// Identify all adverbs
export function buildAdverbIdentify() {
  return {
    questionType: "IDENTIFY",
    question: "Type all adverbs in this sentence, separated by commas: 'He ran very quickly and finished first.'",
    correctAnswers: ["very", "quickly"]
  };
}

// Rhetorical Adverb
export function buildRhetoricalAdverbMC() {
  return {
    questionType: "MC",
    question: "Which sentence uses an adverb to emphasize certainty?",
    correctAnswer: "Undoubtedly, this theory will change science.",
    options: shuffleArray([
      "Undoubtedly, this theory will change science.",
      "This theory is new.",
      "Science changes every year.",
      "The theory was presented at the conference."
    ])
  };
}

// FITB: Write a sentence with 'consequently'
export function buildFITBConsequently() {
  return {
    questionType: "FITB",
    question: "Write a sentence using the adverb 'consequently'.",
    correctAnswer: "consequently",
    checkType: "keyword-in-sentence",
    requiredWord: "consequently"
  };
}

export const allAdvancedAdverbQuestions = [
  buildAdverbClauseMC,
  buildComparativeSuperlativeAdverbMC,
  buildIntensifierMC,
  buildAdverbPlacementMC,
  buildAdverbIdentify,
  buildRhetoricalAdverbMC,
  buildFITBConsequently,
];
